// Merge only fields that the current state form supports. Keeping this logic
// shared prevents individual forms from silently dropping returned fields.
export const mergeLookupDetails = (currentForm, detail = {}) =>
  Object.keys(currentForm).reduce((merged, key) => {
    if (
      key !== "vehicleNo" &&
      detail[key] !== undefined &&
      detail[key] !== null &&
      detail[key] !== ""
    ) {
      merged[key] =
        key === "fromState"
          ? String(detail[key]).trim().toUpperCase()
          : key === "goodsName"
          ? String(detail[key]).trim().toUpperCase()
          : detail[key];
    }
    return merged;
  }, {});
